export const defaultSchema = {
  type: 'object',
  required: [
    'action',
    'advertiser',
    'description',
    'headline',
    'media_url',
    'name',
    'thumbnail_url'
  ],
  properties: {
    action: { $ref: '#/definitions/non-empty-string' },
    advertiser: { $ref: '#/definitions/non-empty-string' },
    media_url: { $ref: '#/definitions/non-empty-string' },
    custom_engagement_url: { type: ['string', 'null'] },
    custom_engagement_label: { type: ['string', 'null'] },
    description: { $ref: '#/definitions/non-empty-string' },
    headline: { $ref: '#/definitions/non-empty-string' },
    isi_text: { type: ['string', 'null'] },
    isi_autoscroll: { type: ['boolean'] },
    js_tracker: { type: ['string', 'null'] },
    name: { $ref: '#/definitions/non-empty-string' },
    opt_out_text: { type: ['string', 'null'] },
    opt_out_url: { type: ['string', 'null'] },
    thumbnail_url: { $ref: '#/definitions/non-empty-string' },
    vast_tag: { type: ['string', 'null'] }
  },
  definitions: {
    'non-empty-string': {
      type: 'string',
      minLength: 1
    }
  }
};

export const hostedVideoSchema = {
  type: 'object',
  required: [
    'action',
    'advertiser',
    'description',
    'headline',
    'name',
    'thumbnail_url'
  ],
  properties: {
    action: { $ref: '#/definitions/non-empty-string' },
    advertiser: { $ref: '#/definitions/non-empty-string' },
    custom_engagement_url: { type: ['string', 'null'] },
    custom_engagement_label: { type: ['string', 'null'] },
    description: { $ref: '#/definitions/non-empty-string' },
    headline: { $ref: '#/definitions/non-empty-string' },
    isi_text: { type: ['string', 'null'] },
    isi_autoscroll: { type: ['boolean'] },
    js_tracker: { type: ['string', 'null'] },
    name: { $ref: '#/definitions/non-empty-string' },
    opt_out_text: { type: ['string', 'null'] },
    opt_out_url: { type: ['string', 'null'] },
    thumbnail_url: { $ref: '#/definitions/non-empty-string' },
    vast_tag: { type: ['string', 'null'] }
  },
  oneOf: [
    {
      required: ['media_url'],
      properties: {
        media_url: { $ref: '#/definitions/non-empty-string' }
      }
    },
    {
      required: ['vast_tag'],
      properties: {
        vast_tag: { $ref: '#/definitions/non-empty-string' }
      }
    }
  ],
  definitions: {
    'non-empty-string': {
      type: 'string',
      minLength: 1
    }
  }
};

export const instreamVideoSchema = {
  type: 'object',
  required: [
    'action',
    'name',
    'custom_engagement_url',
    'media_url'
  ],
  properties: {
    action: { value: 'instream-video' },
    custom_engagement_url: { $ref: '#/definitions/non-empty-string' },
    name: { $ref: '#/definitions/non-empty-string' },
    media_url: { $ref: '#/definitions/non-empty-string' }
  },
  definitions: {
    'non-empty-string': {
      type: 'string',
      minLength: 1
    }
  }
};

export const videoCardSchema = {
  type: 'object',
  required: [
    'action',
    'advertiser',
    'description',
    'headline',
    'name',
    'thumbnail_url'
  ],
  properties: {
    action: { $ref: '#/definitions/non-empty-string' },
    advertiser: { $ref: '#/definitions/non-empty-string' },
    media_url: { $ref: '#/definitions/non-empty-string' },
    custom_engagement_url: { type: ['string', 'null'] },
    custom_engagement_label: { type: ['string', 'null'] },
    description: { $ref: '#/definitions/non-empty-string' },
    headline: { $ref: '#/definitions/non-empty-string' },
    js_tracker: { type: ['string', 'null'] },
    name: { $ref: '#/definitions/non-empty-string' },
    opt_out_text: { type: ['string', 'null'] },
    opt_out_url: { type: ['string', 'null'] },
    thumbnail_url: { $ref: '#/definitions/non-empty-string' }
  },
  definitions: {
    'non-empty-string': {
      type: 'string',
      minLength: 1
    }
  }
};

export const enhancedDisplaySchema = {
  type: 'object',
  required: ['action', 'adm', 'advertiser', 'description', 'headline', 'name'],
  properties: {
    action: { type: 'string', enum: ['banner'] },
    adm: { $ref: '#/definitions/non-empty-string' },
    advertiser: { $ref: '#/definitions/non-empty-string' },
    description: { $ref: '#/definitions/non-empty-string' },
    headline: { $ref: '#/definitions/non-empty-string' },
    name: { $ref: '#/definitions/non-empty-string' },
    media_url: { type: ['string', 'null'] }
  },
  definitions: {
    'non-empty-string': {
      type: 'string',
      minLength: 1
    },
    nullOrBlank: {
      anyOf: [
        {
          type: 'string',
          maxLength: 0
        },
        {
          type: 'null'
        }
      ]
    }
  }
};

// Standard outstream
export const outstreamSchema = {
  type: 'object',
  required: ['action', 'media_url', 'name', 'vast_tag'],
  properties: {
    action: { type: 'string', enum: ['outstream'] },
    name: { $ref: '#/definitions/non-empty-string' },
    media_url: { type: ['string', 'null'] },
    thumbnail_url: { $ref: '#/definitions/non-empty-string' },
    vast_tag: { type: ['string', 'null'] }
  },
  definitions: {
    'non-empty-string': {
      type: 'string',
      minLength: 1
    }
  }
};

export const scrollerSchema = {
  type: 'object',
  required: [
    'action',
    'advertiser',
    'description',
    'headline',
    'media_url',
    'name',
    'thumbnail_url',
    'scroll_direction'
  ],
  properties: {
    action: { type: 'string', enum: ['scroller'] },
    advertiser: { $ref: '#/definitions/non-empty-string' },
    media_url: { $ref: '#/definitions/non-empty-string' },
    custom_engagement_url: { type: ['string', 'null'] },
    custom_engagement_label: { type: ['string', 'null'] },
    description: { $ref: '#/definitions/non-empty-string' },
    headline: { $ref: '#/definitions/non-empty-string' },
    js_tracker: { type: ['string', 'null'] },
    name: { $ref: '#/definitions/non-empty-string' },
    opt_out_text: { type: ['string', 'null'] },
    opt_out_url: { type: ['string', 'null'] },
    thumbnail_url: { $ref: '#/definitions/non-empty-string' },
    scroll_direction: { $ref: '#/definitions/non-empty-string' }
  },
  definitions: {
    'non-empty-string': {
      type: 'string',
      minLength: 1
    }
  }
};

export const thumbnailCarouselSchema = {
  type: 'object',
  required: [
    'action',
    'advertiser',
    'description',
    'headline',
    'media_url',
    'name',
    'slides'
  ],
  properties: {
    action: { type: 'string', enum: ['slideshow'] },
    advertiser: { $ref: '#/definitions/non-empty-string' },
    media_url: { $ref: '#/definitions/non-empty-string' },
    custom_engagement_url: { type: ['string', 'null'] },
    custom_engagement_label: { type: ['string', 'null'] },
    description: { $ref: '#/definitions/non-empty-string' },
    headline: { $ref: '#/definitions/non-empty-string' },
    js_tracker: { type: ['string', 'null'] },
    name: { $ref: '#/definitions/non-empty-string' },
    opt_out_text: { type: ['string', 'null'] },
    opt_out_url: { type: ['string', 'null'] },
    slides: {
      type: 'array',
      items: {
        type: 'object',
        required: ['thumbnail_url'],
        properties: {
          thumbnail_url: { $ref: '#/definitions/non-empty-string' }
        }
      },
      minLength: 2
    }
  },
  definitions: {
    'non-empty-string': {
      type: 'string',
      minLength: 1
    }
  }
};

export const fullAdCarouselSchema = {
  type: 'object',
  required: ['action', 'advertiser', 'name', 'slides'],
  properties: {
    action: { type: 'string', enum: ['carousel'] },
    advertiser: { $ref: '#/definitions/non-empty-string' },
    custom_engagement_url: { type: ['string', 'null'] },
    custom_engagement_label: { type: ['string', 'null'] },
    js_tracker: { type: ['string', 'null'] },
    name: { $ref: '#/definitions/non-empty-string' },
    opt_out_text: { type: ['string', 'null'] },
    opt_out_url: { type: ['string', 'null'] },
    slides: {
      type: 'array',
      items: {
        type: 'object',
        required: ['description', 'headline', 'media_url', 'thumbnail_url'],
        properties: {
          description: { $ref: '#/definitions/non-empty-string' },
          headline: { $ref: '#/definitions/non-empty-string' },
          media_url: { $ref: '#/definitions/non-empty-string' },
          thumbnail_url: { $ref: '#/definitions/non-empty-string' }
        }
      },
      minLength: 2
    }
  },
  definitions: {
    'non-empty-string': {
      type: 'string',
      minLength: 1
    }
  }
};
